import { useEffect, useState } from 'react';
import { fetchData, cellWithMultipleLines, textwithImg } from './Helpers';
import { freeWImg, privateImg, privateWImg, professionalImg, resolveImage, pricingImg, endpointImg } from "../../images/ImageResolver";
import PricingServices from './PricingServices';
import Endpoints from './Endpoints';

export default function StreamingQuotes({tabIndex}) {
  const [loader, setLoader] = useState(true);
  const [fullData, setFullData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); 
  const [hasPublicData, setHasPublicData] = useState(false);
  const tabs = ["Exchange Traded Instrument (ETI)", "Refinitiv Indices", "Economic Indicators", "Fixed Income", "FX Real-time"];
  const [displaySection, setDisplaySection] = useState("grid");

  function filterData(packageType){
    setDisplaySection("grid");
    if(packageType){
      setFilteredData(fullData.filter(item => item.useCase === packageType));
    }else{
      setFilteredData(fullData);
    }
  }

  useEffect(() => {
    const tabs2 = ["Exchange Traded Instrument (ETI)", "Refinitiv Indices", "Economic Indicators", "Fixed Income", "FX Real-time"];
    fetchData("streaming_quotes").then(res => {
      let data = res.filter(item => item.package?.startsWith(tabs2[tabIndex]));
      let publicData = data.filter(item => item.useCase === "Public Redistribution");
      let privateData = data.filter(item => item.useCase === "Redistribution Private");
      setFullData(data);
      if(publicData.length > 0){
        setFilteredData(publicData);
        setHasPublicData(true);
      }else{
        setFilteredData(privateData);
        setHasPublicData(false);
      }
      setLoader(false);
    });
    const buttonBar = document.getElementById('wealthBar');
    const buttons = buttonBar.querySelectorAll('ef-button');
    buttons.forEach((btn, index) => {
      if(index === 0){
        btn.active = true;
      }else{
        btn.active = false;
      }
    });
  }, [tabIndex]);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
    });
  }, []);

  useEffect(() => {
    if(displaySection === "grid"){
      const grid = document.getElementById("grid");
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 50,
        columns: [
          { name: 'Package', field: 'package', width: 4, scalable: true, binding: cellWithMultipleLines},
          { name: 'PLI Code', field: 'pliCode', width: 2, scalable: true},
          { name: 'PLI Description', field: 'pliDescription', width: 6, scalable: true, binding: cellWithMultipleLines},
          { name: 'Region', field: 'region', width: 3, scalable: true},
          { name: 'Delivery', field: 'delivery', width: 2, scalable: true},
          { name: 'Delivery Solution', field: 'deliverySolution', width: 4, scalable: true, contentWrap: true, binding: cellWithMultipleLines},
          { name: 'Reference', field: 'documentReference', width: 2, scalable: true, binding: textwithImg}
        ],
        dataModel: {
          data: filteredData,
        }
      };
    }
  }, [filteredData, displaySection]);

  return (
    <div className='snapshot-div main-div'>
      <ef-loader class="loader" hidden={!loader}></ef-loader>
      {displaySection === "grid" && <h4>{tabs[tabIndex]}</h4>}
      {displaySection === "pricing" && <>
        <h4>PRICING SERVICES SPECIFICATION</h4>
        <p>The Pricing services are available on platform services. Each service has a "Service Name" and has it's own technical specifications.</p>
      </>}
      {displaySection === "endpoints" && <>
        <h4>Available Endpoints per Subscription:</h4>
        <p>When a Wealth client signs for a snapshot or streaming pricing package, access to multiple endpoints on the platform is granted. Below table gives the  overview of endpoints per subscription.</p>
      </>}
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              {hasPublicData && <ef-button id="free" toggles active onClick={() => filterData("Public Redistribution")}><img src={freeWImg} alt="Public"/>Public Redistribution</ef-button>}
              <ef-button id="private" active={!hasPublicData} toggles onClick={() => filterData("Redistribution Private")}><img src={hasPublicData ? privateImg : privateWImg} alt="Private"/>Private Redistribution</ef-button>
              <ef-button id="professional" active toggles onClick={() => filterData("Professional")}><img src={professionalImg} alt="Professional"/>Professional</ef-button>
              <ef-button id="pricing" toggles onClick={() => setDisplaySection("pricing")}><img src={pricingImg} alt="Pricing"/>Pricing Services</ef-button>
              <ef-button id="endpoint" toggles onClick={() => setDisplaySection("endpoints")}><img src={endpointImg} alt="Endpoints"/>Endpoints</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {displaySection === "grid" && (
        <ef-layout>
          <efx-grid id="grid" class="entity-grid"></efx-grid>
        </ef-layout>
      )}
      {displaySection === "pricing" && <PricingServices data={filteredData} />}
      {displaySection === "endpoints" && <Endpoints data={filteredData} />}
    </div>
  );
}